module.exports = __webpack_public_path__ + "83e53f1b89071ac0a62a7d5fc940c795.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/logo.png
// module id = 758
// module chunks = 0